import React from "react";
import ArticleDetail from "../ArticleDetail";

const BlogDetail = () => {
  return <ArticleDetail type="Blog"></ArticleDetail>;
};

export default BlogDetail;
